import McpPermission from '@/bundles/Roles/models/McpPermission';
import { IMcpPermissionApi } from '@/bundles/Roles/types';

export default class McpPermissionMapper {
  mapToModel (data: IMcpPermissionApi): McpPermission {
    return new McpPermission(data);
  }
}
